import { render, staticRenderFns } from "./QACategoryCenterTable.vue?vue&type=template&id=ba690c1c&scoped=true&"
import script from "./QACategoryCenterTable.vue?vue&type=script&lang=js&"
export * from "./QACategoryCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./QACategoryCenterTable.vue?vue&type=style&index=0&id=ba690c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba690c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
